<template src="./template/modal-add-new-boat.html"> </template>

<script>
import DibbleJS from "../../dibble";
import DibbleApi from "../../api";

export default {
    name: "ModalAddNewBoat",
    props: {
        boatType: Number
    },
    data() {
        return {
            mode: 'add',
            data: null,
            serial: '',
            notes: ''
        }
    },
    created() {
        this.$parent.$on('setBoatData', this.loadData);
    },
    methods: {
        loadData(data) {
            this.data = data
            this.mode = 'edit'
            this.serial = this.data.boat_serial
            this.notes = this.data.notes
        },
        closeModal() {
            this.$emit('close');
        },
        resetModalData() {
            this.mode = 'add';
            this.data = null;
            this.serial = '';
            this.notes = '';
        },
        saveBoatInfo() {
            if (this.mode === 'add') {
                this.performAddBoat()
            } else {
                this.updateBoat()
            }
        },
        deleteBoat() {
            DibbleJS.confirmBox('Are you sure you want to delete this boat?', () => {
                DibbleJS.showLoader()
                DibbleJS.callApiRequest({
                    request: DibbleApi.api.deleteRentalBoat,
                    boat_id: this.data.boat_id
                }, response => {
                    DibbleJS.hideLoader();
                    if (DibbleApi.isResponseSuccess(response)) {
                        DibbleJS.toastSuccessMessage(response.message)
                        this.closeModal()
                        this.$emit('modalListener', 'reload');
                    } else {
                        DibbleJS.toastErrorMessage(response.message)
                    }
                })
            })
        },
        performAddBoat() {
            if (this.serial === '') {
                DibbleJS.toastErrorMessage("Please enter the boat number")
                return false
            }

            const params = {
                request: DibbleApi.api.addRentalBoat,
                boat_type: this.boatType,
                serial: this.serial,
                notes: this.notes
            }

            DibbleJS.showLoader()
            DibbleJS.callApiRequest(params, this._onAddBoatSuccess)
        },
        updateBoat() {
            if (this.serial === '') {
                DibbleJS.toastErrorMessage("Please enter the boat number")
                return false
            }

            const params = {
                request: DibbleApi.api.updateRentalBoat,
                boat_type: this.boatType,
                boat_id: this.data.boat_id,
                serial: this.serial,
                notes: this.notes
            }

            DibbleJS.showLoader()
            DibbleJS.callApiRequest(params, this._onAddBoatSuccess)
        },
        _onAddBoatSuccess(response) {
            DibbleJS.hideLoader();
            if (DibbleApi.isResponseSuccess(response)) {
                DibbleJS.toastSuccessMessage(response.message)
                this.resetModalData()
                this.$emit('modalListener', 'reload');
            } else {
                DibbleJS.toastErrorMessage(response.message)
            }
        }
    }
}
</script>

<style>
    #modalEditBanner {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.3);
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .modal {
        background: #FFFFFF;
        transition: opacity .15s linear;
        box-shadow: 2px 2px 20px 1px;
        overflow-x: auto;
        display: flex;
        flex-direction: column;
    }
    .modal-fade-enter,
    .modal-fade-leave-active {
        opacity: 0;
    }

    .modal-fade-enter-active,
    .modal-fade-leave-active {
        transition: opacity .5s ease
    }
</style>
